import { render, staticRenderFns } from "./LogoutSuccess.vue?vue&type=template&id=8f9d8aa2&scoped=true&"
var script = {}
import style0 from "./LogoutSuccess.vue?vue&type=style&index=0&id=8f9d8aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9d8aa2",
  null
  
)

export default component.exports